import { type DriveFile } from '@/shared/DriveTypes';
import { Add, MoreHoriz } from '@mui/icons-material';
import { useTreeMenu } from '~/utils/hooks/hooks';
import { useOpenId, useTheme } from '~/utils/store';
import * as styles from './Tree.css';
import { iconTypes } from './treeMenuUtils';

export const TreeMenuButtons = ({ file, wiki }: { file: DriveFile; wiki: DriveFile }) => {
  const { addMenu, moreMenu } = useTreeMenu();
  const { fontColor } = wiki.properties ?? {};
  const { openId, setOpenId } = useOpenId('tree');
  const theme = useTheme();
  const color = theme === 'light' ? (fontColor ?? '#fff') : '#fff';

  return (
    <>
      <div
        className={styles.menuContainer}
        style={{
          display: openId === file.id ? 'flex' : undefined,
        }}
      >
        <button
          data-id={file.id}
          className={styles.menuButton}
          type="button"
          data-icon={iconTypes.add}
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
            setOpenId(file.id);
            addMenu.setAnchorEl(e.currentTarget);
            addMenu.open();
          }}
        >
          <Add htmlColor={color} />
        </button>
        <button
          data-id={file.id}
          className={styles.menuButton}
          type="button"
          data-icon={iconTypes.more}
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
            setOpenId(file.id);
            moreMenu.setAnchorEl(e.currentTarget);
            moreMenu.open();
          }}
        >
          <MoreHoriz htmlColor={color} />
        </button>
      </div>
    </>
  );
};
